import {del, get, post, put} from "@/services/api"


const state = {
    answers: [],
    didLoadedAnswers: false,
    textForYesNoAnswers: [
        {
            // temporary id
            id: -1,
            text: 'Ano',
            locKey: 'gamification.yes',
            correct: true
        },
        {
            // temporary id
            id: -2,
            text: 'Ne',
            locKey: 'gamification.no',
            correct: false
        },
    ],
};

const getters = {
    getAnswers: state => state.answers,
    displayedAnswers: state => state.answers.filter(a => !a.toDelete),
    didLoadedAnswers: state => state.didLoadedAnswers,
    getYesNoText: state => state.textForYesNoAnswers,
    invalid: (state, getters) => {

        // at least one answer must be true
        const falseAnswers = getters.displayedAnswers.every(a => a.correct === false)

        // every answer must have text
        const emptyText = getters.displayedAnswers.some(a => !a.text || a.text.length === 0)

        return emptyText || falseAnswers
    },
    prepareNewAnswer: () => () => ({
        text: '',
        correct: false,
        questionId: null,
        toDelete: false
    })
};

const actions = {

    async fetchAllAnswers({commit}) {
        commit('setDidLoadedAnswers', false);
        await get('gamification/test_answers/')
            .then((response) => {
                commit('setAnswers', response.data.items);
                commit('setDidLoadedAnswers', true);
            });
    },

    async fetchAnswerById({commit}, id) {
        commit('setDidLoadedAnswers', false);
        const response = await get('gamification/test_answers/' + id);
        commit('updateAnswer', response.data.content);
        commit('setDidLoadedAnswers', true);
    },

    async createAnswer({commit}, {item}) {
        const response = await post('gamification/test_answers/', item);
        const newAnswer = response.data.content;
        commit('addAnswer', newAnswer);
        return newAnswer.id;
    },

    async deleteAnswerById({commit}, id) {
        await del(`gamification/test_answers/${id}`)
            .then(() => {
                commit('filterAnswers', id);
            })
    },

    async updateAnswer({commit}, {item}) {
        await put(`gamification/test_answers/${item.id}`, item)
            .then((response) => {
                commit('updateAnswer', response);
            });
    },
    pushClearAnswer({commit}, temporaryId){
        commit('pushAnswer', temporaryId)
    },
    clearAnswers({commit}){
        commit('setAnswers',[])
    },
};

const mutations = {
    setDidLoadedAnswers: (state, value) => (state.didLoadedAnswers = value),
    addAnswer: (state, item) => (state.answers.push(item)),
    pushAnswer: (state, temporaryId) => (state.answers.push({id: temporaryId, text: '', correct: false, questionId: null, toDelete: false})),
    setAnswers: (state, answers) => { state.answers = answers },
    filterAnswers: (state, id) => (state.answers = state.answers.filter(answer => answer.id !== id)),
    updateAnswer: (state, item) => {
        const existing = state.answers.findIndex(a => a.id === item.id);
        if (existing > -1) {
            state.answers.splice(existing, 1, item);
        } else {
            state.answers.push(item);
        }
    },
    setSingleCorrectAnswer: (state, id) => {
        state.answers.forEach(a => {
            a.correct = a.id === id
        })
    },
    setToDelete: (state, id) => {
        state.answers.forEach((a)=>{
            if(a.id === id){
                a.toDelete = true
            }
        })
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}